module.exports = __webpack_public_path__ + "img/photo-0140.77f4d3b4.jpg";